<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
      </div>
      <div class="col-md fieldset">

        <div class="row">
          <app-form-group label="Inbound">
            <input [(ngModel)]="exemption.inboundTrip" (ngModelChange)="resetInboundTrip()" id="inboundTrip"
                   type="checkbox" class="form-check-input">
          </app-form-group>
        </div>

        <div class="row">
          @if (exemption.inboundTrip) {
            <div>
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>Inbound trip start date</label>
                  <div class="tooltipContent">ETA of entering the Oude Maas</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.inboundTripStartDate" id="inboundTripStartDate"
                                required></app-date-field>
              </app-form-group>
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>Inbound trip end date</label>
                  <div class="tooltipContent">ETD of leaving the Oude Maas</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.inboundTripEndDate" id="inboundTripEndDate"
                                required></app-date-field>
              </app-form-group>
              <app-form-group label="Start location entering Oude Maas">
                <input [(ngModel)]="exemption.inboundLocationName" id="inboundTripName" type="text" maxlength="256"
                       class="form-control" required>
              </app-form-group>
              <app-form-group label="Inbound trip freshwater draft (dm)">
                <input [(ngModel)]="exemption.inboundTripFreshWaterDraft" id="inboundTripFreshWaterDraft" type="number"
                       maxlength="256" class="form-control" required>
              </app-form-group>
              <app-form-group label="Inbound trip air-draft (dm)">
                <input [(ngModel)]="exemption.inboundTripAirDraft" id="inboundTripAirDraft" type="number"
                       maxlength="256" class="form-control" required>
              </app-form-group>
            </div>
          }
        </div>

        <div class="row">
          <app-form-group label="Outbound">
            <input [(ngModel)]="exemption.outboundTrip" (ngModelChange)="resetOutboundTrip()" id="outboundTrip"
                   type="checkbox" class="form-check-input">
          </app-form-group>
        </div>
        <div class="row">
          @if (exemption.outboundTrip) {
            <div>
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>Outbound trip start date</label>
                  <div class="tooltipContent">ETA of entering the Oude Maas</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.outboundTripStartDate" id="outboundTripStartDate"
                                required></app-date-field>
              </app-form-group>
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>Outbound trip end date</label>
                  <div class="tooltipContent">ETD of leaving the Oude Maas</div>
                </app-info>
                <app-date-field [(ngModel)]="exemption.outboundTripEndDate" id="outboundTripEndDate"
                                required></app-date-field>
              </app-form-group>
              <app-form-group label="End Location leaving Oude Maas">
                <input [(ngModel)]="exemption.outboundLocationName" id="outboundTripName" type="text" maxlength="256"
                       class="form-control" required>
              </app-form-group>
              <app-form-group label="Outbound trip freshwater draft (dm)">
                <input [(ngModel)]="exemption.outboundTripFreshWaterDraft" id="outboundTripFreshWaterDraft"
                       type="number" maxlength="256" class="form-control" required>
              </app-form-group>
              <app-form-group label="Outbound trip air-draft (dm)">
                <input [(ngModel)]="exemption.outboundTripAirDraft" id="outboundTripAirDraft" type="number"
                       maxlength="256" class="form-control" required>
              </app-form-group>
            </div>
          }
        </div>

        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
